const LOG_LEVELS = {
  debug: 0,
  info: 1,
  log: 2,
  warn: 3,
  error: 4
};
const LOG_STYLES = {
  debug: "color: #fff; background: #333; font-weight: bold;",
  info: "color: #06f; font-weight: bold;",
  log: "color: #fff; background: #000; font-weight: bold;",
  warn: "color: #f90; font-weight: bold;",
  error: "color: #f00; font-weight: bold;"
};
const PACKAGE_STYLES = {
  "One-App": "color: #D7591B; font-weight: bold;",
  "Data-Provider": "color: #908059; font-weight: bold;",
  Parser: "color: #337FD1; font-weight: bold;",
  Engine: "color: #43511F; font-weight: bold;"
};
const isClient = () => {
  try {
    return typeof window !== "undefined" && typeof window.document !== "undefined";
  } catch (e) {
    console.debug("Logger: isClient check failed", e);
    return false;
  }
};
class Logger {
  logger;
  packageId;
  constructor(packageId, scope = "", options = {}) {
    if (!packageId) {
      throw new Error("Package ID is required to create a logger");
    }
    const {
      level = "log"
    } = options;
    this.logger = {
      debug: () => void 0,
      info: () => void 0,
      log: () => void 0,
      warn: () => void 0,
      error: () => void 0
    };
    this.packageId = packageId;
    const minLevel = LOG_LEVELS[level];
    for (const lvl of Object.keys(LOG_LEVELS)) {
      if (LOG_LEVELS[lvl] >= minLevel) {
        this.logger[lvl] = console[lvl].bind(
          isClient() ? window.console || console : console,
          ...this.formatMessage(lvl, scope)
        );
      } else {
        this.logger[lvl] = () => void 0;
      }
    }
  }
  formatMessage(level, scope, step = "", ...args) {
    const structuredArgs = !isClient() && process.env.NODE_ENV === "production" ? args.map((arg) => typeof arg === "object" ? JSON.stringify(arg) : arg) : args;
    const format = [
      `%c[${level}]%c[${this.packageId}:${scope}] %c${step}`,
      LOG_STYLES[level],
      PACKAGE_STYLES[this.packageId] || "color: #000; font-weight: normal;",
      "color: #fff; font-weight: normal;",
      ...structuredArgs
    ];
    return format;
  }
}
function createLogger(packageId, scope, options = {}) {
  return new Logger(packageId, scope, options);
}
export {
  createLogger
};
